import { render, staticRenderFns } from "./RegisterAccount.vue?vue&type=template&id=1af7e2f0"
import script from "./RegisterAccount.vue?vue&type=script&lang=js"
export * from "./RegisterAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports